<template>
  <v-card flat>
    <div class="text-center pa-4">
      <div class="text-center">
        <strong v-if="metrics.length == 0">Nenhuma métrica encontrada</strong>

        <v-simple-table class="main-table mt-0" v-else>
          <thead>
            <tr>
              <th class="text-center"></th>
              <th class="text-center">Métrica</th>
              <th class="text-center">Resolução</th>
              <th class="text-center">Pontos</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in metrics" :key="item.id">
              <td class="text-center"></td>
              <td class="text-center">
                {{ item.metric ? item.metric.name : '' }}
              </td>
              <td class="text-center">
                <h3>{{ item.resolution }}</h3>
              </td>
              <td class="text-center">
                <strong
                  class="font-weight-bold"
                  v-if="item.ranges && item.ranges.length == 0"
                >
                  <div class="my-3">Nenhum ponto encontrada</div>
                </strong>

                <v-simple-table class="main-table" v-else>
                  <thead>
                    <tr>
                      <th class="text-center"></th>
                      <th class="text-center">Ponto</th>
                      <th class="text-center">K</th>
                      <th class="text-center">Incerteza</th>
                      <th class="text-center">Tendência</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="range in item.ranges" :key="range.id">
                      <td></td>
                      <td>{{ range.range }}</td>
                      <td>{{ range.k }}</td>
                      <td>{{ range.uncertainty }}</td>
                      <td>{{ range.tendency }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </td>
              <td></td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'PatternMetricsV2',

  props: {
    patternId: Number,
  },

  data() {
    return {
      selectedRange: {},
      metrics: [],
      filter: {
        patternId: null,
        page: 1,
        pageSize: 10,
      },
      apiService: new ApiService(),
      metricId: false,
    }
  },

  created() {
    this.list()
  },

  methods: {
    list() {
      const id = this.patternId

      if (id) this.filter.patternId = id

      this.apiService
        .get('calibration/v2/pattern/metric/paginate', this.filter)
        .then((response) => {
          this.metrics = response.content.data
        })
    },
  },
}
</script>

<style></style>
